import {
    Alert, Box, Button, Checkbox, Divider, FormControl, FormControlLabel,
    FormHelperText, FormLabel, Grid, IconButton, InputLabel, ListItemText, MenuItem,
    Radio, RadioGroup, Select, TextField, Tooltip, Typography, Modal, Backdrop, Fade
} from "@mui/material";
import { hospitalsApplyFormProps, requiredHospitalsApplyFormProps, supportTimeframeValues } from "../../consts/form-helpers/form-consts";
import { hospitalApply, getHospitalDetailsByHash, editHospital, getHospitalEmail, getHospitalEditPin } from "../../services/apply-service";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './request-support-apply.css';
import { Delete, Download, UploadFile } from "@mui/icons-material";
import { FormGroup, Slider, Table, TableBody, TableCell, TableHead, TableRow, Step, Stepper, StepLabel } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { availabilityValues, expertsApplyFormProps, generalAvailabilityValues, languageMarksValues, languagesValues, level, proficienyValues, regionalExperienceValues, registryRelatedExperienceValues, requiredExpertsApplyFormProps, specialtyFieldsValues, whoRegionCountries, yearsOfExperienceRange } from "../../consts/form-helpers/form-consts";
import { expertApply, expertEdit, getExpertByEmailHash, getExpertEndorsment, getExpertResume, verifyCaptcha, getExpertEmail, getExpertPin, GetFile } from "../../services/apply-service";
import './request-support-apply.css';
import { AppRoutes } from '../../consts/routes/app-routes';
import { customHasher } from "../../consts/helpers/customHasher";
import IntroStep from "./request-support-form-steps/intro-step";
import GeneralInfoStep from "./request-support-form-steps/general-info-step";
import AboutStep from "./request-support-form-steps/about-step";
import RequestSupportStep from "./request-support-form-steps/request-support-step";
import TypeOfSupportStep from "./request-support-form-steps/type-of-support-step";
import SubmissionStep from "./request-support-form-steps/submission-step";

const RequestSupportApplyComponent = () => {
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [confirmInformationIsTrue, setConfirmInformationIsTrue] = useState(false);
    const [error, setError] = useState(null);
    const [emailError, setEmailError] = useState(false);
    const [emptyFormProps, setEmptyFormProps] = useState([]);
    const [acceptTermsError, setAcceptTermsError] = useState('');
    const [confirmInformationIsTrueError, setConfirmInformationIsTrueError] = useState('');
    const [formData, setFormData] = useState({ ...hospitalsApplyFormProps });
    const [isSuccess, setIsSuccess] = useState(false);
    const [captchaToken, setCaptchaToken] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [emailHash, setEmailHash] = useState(false);
    const [fieldsToUpdate, setFieldsToUpdate] = useState({});
    const [isFieldOfExpertiseEdited, setIsFieldOfExpertiseEdited] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [enteredEmail, setEnteredEmail] = useState("");
    const [enteredPin, setEnteredPin] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [validationError, setValidationError] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFields, setSelectedFields] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [beginRegistration, setBeginRegistration] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const specialtyFields = [...specialtyFieldsValues];

    const [selection, setSelection] = useState(null);
    const [visitDescription, setVisitDescription] = useState('');
    const [confirmSupport, setConfirmSupport] = useState(false);


    const steps = ['General information', 'About the hospital', 'Request for support', 'Type of support', 'Submission'];

    const validateStep = (step) => {
        if (step === 0) {
            const missing = ['name', 'address', 'city', 'country', 'phone_number', 'email', 'contact_person'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 1) {
            const missing = ['num_of_employees', 'num_of_beds', 'num_of_outpatients', 'institution_level_id', 'requested_support_description'].filter((field) => (!formData[field] || formData[field].length === 0));
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 2) {
            const missing = ['requested_support_reason', 'expert_work_expectations', 'expected_project_outcome'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            return missing.length === 0;
        }

        if (step === 3) {
            console.log(formData);
            const missing = ['support_timeframe', 'method_of_support'].filter((field) => !formData[field]);
            setEmptyFormProps(missing);
            console.log(emptyFormProps);
            console.log(missing);
            return missing.length === 0;
        }
    };

    const nextStep = () => {
        if (!validateStep(currentStep)) return;
        setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
    };

    const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (window.location.search !== '') {
            setIsEdit(true);
            const hash = new URLSearchParams(window.location.search).get('h');
            setEmailHash(hash);

            getHospitalDetailsByHash(hash)
                .then(res => {
                    console.log('Hospital data:', res);
                    const expertiseIds = res.fields_of_expertise?.map(item => item.id) || [];
                    setFormData({ ...res, field_of_expertise_ids: expertiseIds });
                    setAcceptTerms(res.terms_and_conditions === true);
                    setConfirmInformationIsTrue(res.information_accuracy_confirmation === true);
                    setSelectedFields(expertiseIds);
                    setIsModalOpen(true);
                }).catch(err => console.log("An error occured", err))

        }
    }, []);

    const handleInputChange = e => {
        setError(null);
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if (isEdit) {
            setFieldsToUpdate({ ...fieldsToUpdate, [e.target.name]: e.target.value })
        }

        if (emptyFormProps.includes(e.target.name)) {
            setEmptyFormProps((props) => props.filter(prop => prop !== e.target.name));
        }
    };

    const handleVisitDescription = (value) => {
        setVisitDescription(value);
        setFormData(prev => ({ ...prev, method_of_support_description: value }));
    }

    const handleCheckboxChange = (option) => {
        setFormData(prev => ({ ...prev, method_of_support: selection === option ? null : option }));
        setSelection(prev => prev === option ? null : option);
        handleVisitDescription('');
        if (emptyFormProps.includes('method_of_support')) {
            setEmptyFormProps((props) => props.filter(prop => prop !== 'method_of_support'));
        }

        if (selection === option) {
            setEmptyFormProps(prev => [...prev, 'method_of_support']);
        }

        console.log(option);
        console.log(selection);
    }

    const handleConfirmSupport = (value) => {
        setConfirmSupport(value);
        setFormData({ ...formData, ['confirm_support']: value });
    }

    const handleAcceptTermsChange = (isChecked) => {
        setAcceptTerms(isChecked);
        setFormData(prev => ({ ...prev, terms_and_conditions: isChecked }));
        if (isEdit) {
            setFieldsToUpdate(prev => ({ ...prev, terms_and_conditions: isChecked }));
        }
        if (isChecked) setAcceptTermsError('');
    };

    const handleConfirmInformationIsTrue = (isChecked) => {
        setConfirmInformationIsTrue(isChecked);
        setFormData(prev => ({ ...prev, information_accuracy_confirmation: isChecked }));
        if (isEdit) {
            setFieldsToUpdate(prev => ({ ...prev, information_accuracy_confirmation: isChecked }));
        }
        if (isChecked) setConfirmInformationIsTrueError('');
    };

    const validateForm = () => {
        let isFormValid = true;

        for (let prop of requiredHospitalsApplyFormProps) {
            if (formData[prop] === '' || formData[prop] === null || formData[prop] === false) {
                if (prop === 'terms_and_conditions') {
                    setAcceptTermsError('You must accept the terms and conditions to proceed.')
                    isFormValid = false;
                };

                if (prop === 'information_accuracy_confirmation') {
                    setConfirmInformationIsTrueError('You must confirm the accuracy of information provided.')
                    isFormValid = false;
                };

                setEmptyFormProps((prev) => [...prev, prop]);
                setError('Please fill out all required fields');
                isFormValid = false;
            };

            if (prop === 'terms_and_conditions' && !acceptTerms) {
                setAcceptTermsError('You must accept the terms and conditions to proceed.');
                setError('Please fill out all required fields');
                isFormValid = false;
            };

            if (prop === 'information_accuracy_confirmation' && !confirmInformationIsTrue) {
                setConfirmInformationIsTrueError('You must confirm the accuracy of information provided.');
                setError('Please fill out all required fields');
                isFormValid = false;
            };
        };

        return isFormValid;
    }

    const handleSubmit = async () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (validateForm()) {
            if (isEdit) {
                const editedData = {
                    id: formData.id,
                    fieldsToUpdate
                };

                if (isFieldOfExpertiseEdited) {
                    editedData.field_of_expertise_ids = formData.field_of_expertise_ids;
                }

                editHospital(editedData).then(res => {
                    console.log(res);
                    setIsSuccess(true);
                    setSuccessMessage('Your application was succesfully edited. You will be contacted for further details.');

                }).catch(err => console.log(err));
            } else {
                hospitalApply(formData).then((res) => { }).catch(er => console.log(er));
                setIsSuccess(true);
                setSuccessMessage('Thank you. Your application was successfully sent. You will be contacted for further details.');

            }
        }
    }

    const handleEmailBlur = () => { setEmailError(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? 'Invalid email format' : '') };

    useEffect(() => {
        setError(null);

        axios.get('https://restcountries.com/v3.1/all?fields=name,flags')
            .then((response) => {
                const newCountries = response.data.map(country => ({
                    label: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    value: country.name.common === 'North Macedonia' ? 'Macedonia' : country.name.common,
                    flag: country.flags.png
                }));

                newCountries.sort((a, b) => a.label.localeCompare(b.label));

                setCountryOptions(newCountries);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleVerify = async () => {
        try {
            const responseEmail = await getHospitalEmail(formData.id);
            const responsePin = await getHospitalEditPin(formData.id);

            // Convert email to lowercase and trim spaces
            const storedEmail = responseEmail.email.trim().toLowerCase();
            const enteredEmailFormatted = enteredEmail.trim().toLowerCase();

            // Convert PIN to a string and trim spaces
            const storedPin = String(responsePin.hospital_pin_edit).trim();
            const enteredPinFormatted = enteredPin.trim();

            // Compare emails and PINs after proper formatting
            if (storedEmail === enteredEmailFormatted && storedPin === enteredPinFormatted) {
                setIsAuthenticated(true);
                setIsModalOpen(false); // Close the modal
            } else {
                setValidationError("Invalid email or PIN. Please try again.");
            }
        } catch (error) {
            setValidationError("Error verifying credentials. Please try again.");
        }
    };

    const handleBeginRegistration = () => setBeginRegistration(prev => !prev);

    const stepContent = [
        <GeneralInfoStep props={{ formData, handleInputChange, emptyFormProps, handleEmailBlur, emailError, countryOptions }} />,
        <AboutStep props={{ specialtyFields, formData, handleInputChange, emptyFormProps, level }} />,
        <RequestSupportStep props={{ formData, handleInputChange, emptyFormProps, isEdit }} />,
        <TypeOfSupportStep props={{ formData, emptyFormProps, isEdit, handleConfirmSupport, handleInputChange, supportTimeframeValues, selection, visitDescription, handleCheckboxChange, handleVisitDescription }} />,
        <SubmissionStep props={{ formData, handleConfirmInformationIsTrue, confirmInformationIsTrue, confirmInformationIsTrueError, handleAcceptTermsChange, acceptTerms, acceptTermsError }} />
    ];

    return (
        <>
            {!beginRegistration && <IntroStep props={{ isModalOpen, handleBeginRegistration }} />}
            {isSuccess && (
                <div className="success-msg-rsa-div">
                    <Alert className="success-msg-alert-rsa" severity="success">
                        <strong><h3>{successMessage}</h3></strong>
                    </Alert>
                </div>
            )}
            {(beginRegistration && !isSuccess) && (
                <>
                    <Typography variant="h4" color={'primary'} m={2.5} textAlign={'center'}>Request Support</Typography>
                    <Box component="form" noValidate autoComplete="off" className="content-rsa-form">
                        <Stepper activeStep={currentStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Box sx={{ mt: 4 }}>{stepContent[currentStep]}</Box>
                        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                            <Button disabled={currentStep === 0} onClick={prevStep}>Back</Button>
                            {currentStep < steps.length - 1 ? (
                                <Button variant="contained" onClick={nextStep}>Next</Button>
                            ) : (<Button variant="contained" onClick={handleSubmit}>Submit</Button>)}
                        </Box>
                        <Grid container spacing={2}>
                        </Grid>
                    </Box>
                </>
            )}
            <Modal open={isModalOpen} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }} >
                <Fade in={isModalOpen}>
                    <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, width: "400px", display: "flex", flexDirection: "column", gap: 2 }}>
                        <Typography variant="h6" align="center">Authentication Required</Typography>
                        <TextField label="Email" fullWidth value={enteredEmail} onChange={(e) => setEnteredEmail(e.target.value)} />
                        <TextField label="PIN" type="number" fullWidth value={enteredPin} onChange={(e) => setEnteredPin(e.target.value)} />
                        {validationError && <Alert severity="error">{validationError}</Alert>}
                        <Button variant="contained" color="primary" onClick={handleVerify}> Send </Button>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

export default RequestSupportApplyComponent;